/*
 *
 * Groups Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 11-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_RESET_ERROR: '@@Groups/reset_error',
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@Groups/set_item_to_show_detail',
	// @generator action:route:type
	...createRequestTypes('@@Groups', 'FETCH_GROUP_DETAIL'),
	...createRequestTypes('@@Groups', 'DELETE_GROUP'),
	...createRequestTypes('@@Groups', 'UPDATE_GROUP'),
	...createRequestTypes('@@Groups', 'CREATE_GROUP'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name fetchGroupDetail
 * @return {object} - The action object
 */
export const fetchGroupDetail = new MakeRequest('Groups', 'fetch_group_detail');

/** @action request
 * * Insert a description
 * @name deleteGroup
 * @return {object} - The action object
 */
export const deleteGroup = new MakeRequest('Groups', 'delete_group');

/** @action request
 * * Insert a description
 * @name updateGroup
 * @return {object} - The action object
 */
export const updateGroup = new MakeRequest('Groups', 'update_group');

/** @action request
 * * Insert a description
 * @name createGroup
 * @return {object} - The action object
 */
export const createGroup = new MakeRequest('Groups', 'create_group');

// @generator action:route:request

/** @action
 * * Insert a description
 * @name SetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });

/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });

// @generator action:route
